import type { GeometryPadWidgetConfig } from '../geometrypad.model';

/**
 * Pythagoras theorem visualization:
 * - 3-4-5 right triangle
 * - Three squares on each side of the triangle
 * - Demonstrates a² + b² = c² (9 + 16 = 25)
 *
 * Uses EdgeTarget to place squares on each edge (exterior side).
 * Each square's bottom edge is aligned to the corresponding triangle edge.
 */
export const PYTHAGORAS_PRESET: GeometryPadWidgetConfig = {
  id: 'pythagoras',
  type: 'geometrypad',
  params: {
    elements: {
      // Right triangle (3-4-5 Pythagorean triple)
      tri: { type: 'Triangle', params: { a: 3, b: 4, c: 5 } },

      // Square on hypotenuse (edge AB) — exterior (below)
      sq_c: {
        type: 'Square',
        params: {
          s: 'tri.c',
          bottom: { ref: 'tri.edge.AB', side: 'exterior' },
        },
      },
      // Square on side a (edge BC) — exterior
      sq_a: {
        type: 'Square',
        params: {
          s: 'tri.a',
          bottom: { ref: 'tri.edge.BC', side: 'exterior' },
        },
      },
      // Square on side b (edge CA) — exterior
      sq_b: {
        type: 'Square',
        params: {
          s: 'tri.b',
          bottom: { ref: 'tri.edge.CA', side: 'exterior' },
        },
      },
    },
  },
  display: {
    geometry: {
      shape: { coloring: true },
      angle: { rightAngleDisplay: 'square' },
      label: { coloring: true },
    },
  },
};
